import React, { useState } from 'react'
import { mail } from '../../utilities/fetch';
import { Link, withRouter } from 'react-router-dom';
import { Card, Container, Row, Col, Button, Modal } from 'react-bootstrap';
import './ShopResume.scss';
import { useStateValue } from '../../utilities/StateProvider';
import ShowResume from './ShowResume';
import ProductResume from './ProductResume';
import ExtrasResume from './ExtrasResume';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

function ShopResume(props) {

    const [{ cart, event, user, isInterior }, _ ] = useStateValue();
    const [ modal, setModal ] = useState(false);

    const renderCartTotal = () => {
        const total = Object.values(cart).map(entry => (((!isInterior) ? entry.price : entry.price_interior) * entry.quantity)).reduce((acc, cur) => (acc + cur), 0);
        return (
            <div className="cart-total">
                <div>Total Compra</div>
                <div>${total}</div>
            </div>
        )
    }

    const renderUserData = () => (
        <div className='data-row'>
            <div><b>Nombre:</b> {user.name} {user.lastname}</div>
            <div><b>Fecha de Nacimiento:</b> {user.birthdate}</div>
            <div><b>Telefono:</b> {user.phone}</div>
        </div>
    );

    const renderEventData = () => (
        <div className='data-row'>
            <div><b>Direccion Entrega:</b> {event.address}</div>
            <div><b>Fecha Evento:</b> {event.date}</div>
            <div><b>Hora Evento:</b> {event.hour} {event.ampm}</div>
            <div><b>Cantidad Personas:</b> {event.quantity}</div>
            <div><b>Tipo Evento:</b> {event.type}</div>
        </div>
    )

    const renderContactData = () => {
        let contact = {};
        if (event.contact) {
            contact = event.contact;
        }
        return (
            <React.Fragment>
                <div><b>Nombre:</b> {contact.name} {contact.lastname}</div>
                <div><b>Telefono:</b> {contact.phone}</div>
            </React.Fragment>
        )
    }

    const renderShowData = () => {
        return (<ShowResume />);
    }

    const renderProductData = () => {
        return (<ProductResume />);
    }

    const renderExtras = () => {
        return (<ExtrasResume />);
    }

    const renderCooler = () => {
        if(!cart.show || !cart.show.cooler) {
            return null
        }

        return (
            <React.Fragment>
                <Col xs="12 title">Personalización Del Cooler</Col>
                <Col xs="12">
                    <div className="cooler-resume">
                        <div>{cart.show.cooler}</div>
                    </div>
                </Col>
            </React.Fragment>
        )
    }

    const confirm = () => {
        const input = document.getElementById('resume-card-container');
        html2canvas(input, {
            height: (input.scrollHeight*1.15),
            width: 1140,
            windowWidth: 1140,
            x: 0,
            y: 80,
            scale: 1.25
        })
        .then(async (canvas) => {
            const imgData = canvas.toDataURL('image/png', 0.5);
            const pdf = new jsPDF({
                orientation: 'p',
                unit: 'px',
                format: [1140, (input.scrollHeight*1.15)]
            });
            pdf.addImage(imgData, 'PNG', 0, 0 );
            const message = orderText();
            mail.post('send', {
                'to': 'pide.panda@gmail.com',
                'subject': `Order Generada ${event.type} ${user.name} ${user.lastname}`,
                'message': message,
            });
            pdf.save('Order PandaMix.pdf');
        });

        setModal(true);
    }

    const orderText = () => {
        let contact = {};
        if (event.contact) {
            contact = event.contact;
        }
        return (
`
Datos de la Orden:
\n
-----------------------------
\n
Nombre: ${user.name} ${user.lastname}
Email: ${user.email}
Telefono: ${user.phone}
\n
Direccion: ${event.address}
Fecha: ${event.date}
Hora: ${event.hour} ${event.ampm}
Cantidad: ${event.quantity}
Tipo: ${event.type}
\n
Nombre Contacto: ${contact.name} ${contact.lastname}
Telefono Contacto: ${contact.phone}
\n
Carrito: \n
${itemsCarrito()}
\n
Cooler: \n
${itemsCooler()}
\n
-----------------------------
\n
Total a Pagar: ${itemsTotal()} $
`
        )
    }

    const itemsTotal = () => {
        const total = Object.values(cart).map(entry => (((!isInterior) ? entry.price : entry.price_interior) * entry.quantity)).reduce((acc, cur) => (acc + cur), 0);
        return total;
    }

    const itemsCarrito = () => {
        const carrito = Object.values(cart).map(entry => ({name: entry.name, quantity: entry.quantity, price: ((!isInterior) ? entry.price : entry.price_interior)}));
        let listaItems = '';
        carrito.forEach(entry => {
            listaItems += `${entry.name}      Cantidad: ${entry.quantity}      Precio total: ${((!isInterior) ? entry.price : entry.price_interior) * entry.quantity} $\n`
        });
        return listaItems;
    }

    const itemsCooler = () => {
        return (cart.show && cart.show.cooler) ? `Personalizacion: ${cart.show.cooler}` : 'N/A';
    }

    const accept = () => {
        sessionStorage.removeItem('cart');
        props.history.push('/#reel');
    }

    return (
        <Container id="resume-card-container">
            <Card className="shop-resume-card" id="shop-resume-card">
                <Card.Body>
                    <Container>
                        <Row>
                            <Col xs="12 title">Resumen de Compra</Col>
                            <Col xs="12 title"><div className="divisor short" /></Col>
                        </Row>
                        <Row className="resume-row">
                            <Col xs="12" md={{offset: 2, span: 4}}>
                                <div className="title">Datos Comprador</div>
                                {renderUserData()}
                            </Col>
                            <div className="divisor invisible" />
                            <Col xs="12" md="4">
                                <div className="title">Datos Contacto</div>
                                {renderContactData()}
                            </Col>
                        </Row>
                        <Row className="resume-row">
                            <Col xs="12 title">Tu Compra</Col>
                            <Col xs="12" md={{offset: 3, span: 6}}>
                                {renderEventData()}
                            </Col>
                            <Col xs="12 title"><div className="divisor short" /></Col>
                        </Row>
                        <Row className="resume-row resume-service">
                            <Col xs="12 title">Tu Servicio</Col>
                            <Col xs="12" md={{offset: 2, span: 8}}>
                                {renderShowData()}
                            </Col>
                            <Col xs="12" md={{offset: 2, span: 8}}>
                                {renderProductData()}
                            </Col>
                        </Row>
                        <Row className="resume-row">
                            {renderCooler()}
                        </Row>
                        <Row className="resume-row">
                            {renderExtras()}
                        </Row>
                        <Row className="resume-row">
                            <Col xs="12">
                                {renderCartTotal()}
                            </Col>
                        </Row>
                        <Row>
                            <Button className="shop-resume-button fill" onClick={confirm}>Confirmar</Button>
                        </Row>
                        <Row>
                            <Link to="/shop" className="shop-resume-button-wrapper">
                                <Button className="shop-resume-button">Retroceder</Button>
                            </Link>
                        </Row>
                    </Container>
                </Card.Body>
                <Card.Footer className="shop-resume-footer">
                    <div className="description">Espera la llamada de nuestra ejecutiva de cuentas para formalizar el pago</div>
                    <div className="divisor" />
                    <div className="subdescription">
                        Las compras en el interior del país generan ciertos cargos adicionales
                        de transporte, estadía y viáticos
                    </div>
                </Card.Footer>
            </Card>
            <Modal show={modal} className="resume-confirm" centered onHide={accept}>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col xs={{offset: 2, span: 8}}>
                                <i className="fas fa-check-circle resume-icon" />
                                Tu orden ha sido generada. Espera la llamada de nuestra ejecutiva
                                de cuentas para formalizar el pago
                                <div className="divisor"/>
                                <div className="subdescription">
                                    Las compras en el interior del país generan ciertos cargos adicionales
                                    de transporte, estadías y viáticos
                                </div>
                                <br />
                                <Button className="shop-resume-button inverse" onClick={accept}>Aceptar</Button>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
        </Container>
    )
}

export default withRouter(ShopResume);